import fetchApi from '@/lib/tools/api'
import {UserProducer} from '@/types'
import {Box, Button} from '@mui/material'
import React, {useCallback} from 'react'
import {useListContext, useNotify, useRecordContext, useRefresh, useUnselectAll} from 'react-admin'

interface UnlinkStoresResponse {
	success: boolean
	unlinkedCount: number
	user: UserProducer
}

export default function LinkedStoresBulkActionsUser() {

	const {selectedIds} = useListContext()
	const record = useRecordContext<UserProducer>()
	const unselectAll = useUnselectAll(`producers/users.${record.id}.producers/stores`)
	const refresh = useRefresh()
	const notify = useNotify()

	const unlink = useCallback(async () => {
		try {
			const response = await fetchApi<UnlinkStoresResponse>(
				`/producers/users/${record.id}/unlink-stores`,
				{storeIds: selectedIds},
				null,
				'POST'
			)

			if (response.success) {
				unselectAll()
				refresh()
				notify(`${response.unlinkedCount} établissement(s) délié(s) avec succès`, {type: 'success'})
			}
		} catch (error) {
			notify('Erreur lors de la déliaison des établissements', {type: 'error'})
			console.error(error)
		}
	}, [selectedIds, record.id, unselectAll, refresh, notify])

	return (
		<Box>
			<Button onClick={unlink} variant="contained" color="error">Délier la sélection</Button>
		</Box>
	)
}
